module.exports = __webpack_public_path__ + "static/media/poor.cf0fa56a.svg";